import React from "react";

const EmptyPlaceHolderCollection = () => {
  return <div className="div-image-colletion"></div>;
};

export default EmptyPlaceHolderCollection;
